﻿import { Segmented } from 'antd';
import React from 'react';

import { CoordinateNotation } from 'msg-ui-react/dist/interfaces/CoordinateNotation';
import { DistanceUnits, DistanceUnitsShortLabel } from 'msg-ui-react/dist/interfaces/DistanceUnits';

import { ComponentConfigsMap } from '../forms/ComponentsMap';
import { UnitsState } from '../models/UnitsState';


const notations: CoordinateNotation[] = ["Deg", "Min", "Sec"];
const units: DistanceUnits[] = ["NM", "cable", "km", "m"];


/**
 * Describes components used to create a UI for unit settings
 */
export const unitsConfig: ComponentConfigsMap<UnitsState> = {
    coordinateNotation: {
        label: "Coordinates",
        component: <Segmented block options={
            notations.map(value => ({
                label: value,
                value,
                title: ''
            }))
        }/>     
        
    },
    distanceUnit: {
        label: "Distance",
        component: <Segmented block options={
            units.map(value => ({
                label: DistanceUnitsShortLabel[value],
                value,
                title: ''
            }))
        } />
    }  
}